import React from 'react'
import './Programs.css'
import { programsData } from '../../data/programsData'
import right_arrow_image from "../../assets/rightArrow.png";

const Programs = () => {
  return (
    <div className="Programs" id="Programs">
        {/* Header*/}
        <div className="programs-header">
            <span class="stroke-text">EXPLORE OUR</span>
            <span>PROGRAMS</span>
            <span class="stroke-text">TO SHAPE YOU</span>
        </div>

        <div className="program-categories">
            {programsData.map((program)=>(
                <div className="category">
                    {program.image}
                    <span>{program.heading}</span>
                    <span>{program.details}</span>
                    <div className="join-now">
                        <span>Join Now</span>
                        <img src={right_arrow_image} alt="" />
                    </div>
                </div>
            ))}
        </div>
    </div>
  )
}

export default Programs
